module.exports = __webpack_public_path__ + "img/venus26.16dd3c0d.png";